import { render, staticRenderFns } from "./back-header.vue?vue&type=template&id=31f6dbba&scoped=true&"
import script from "./back-header.vue?vue&type=script&lang=js&"
export * from "./back-header.vue?vue&type=script&lang=js&"
import style0 from "./back-header.vue?vue&type=style&index=0&id=31f6dbba&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f6dbba",
  null
  
)

export default component.exports